import { useState } from 'react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import clsx from 'clsx'
import PdImage from '@components/pd-image/pd-image'
import FormBeforeDownload from '@components/standard/form-before-download'

interface DownloadCardProps {
  img: string
  title: string
  desc: string
  jumpUrl: string
  downloadUrlTitle?: string
}

type DownloadMetaType = {
  show: boolean
  url: string
  filename: string
}

const DownloadCard = ({ img, title, desc, jumpUrl, downloadUrlTitle }: DownloadCardProps) => {
  const t = useTranslations()
  const [downloadMeta, setDownloadMeta] = useState<DownloadMetaType>({ show: false, url: '', filename: '' })

  function startDownload(url: string, filename: string) {
    setDownloadMeta({ url, filename, show: true })
  }

  return (
    <>
      <div
        className={clsx(
          'bg-gray-100 inline-flex justify-start items-start',
          'p-3 gap-3 w-full',
          'laptop:p-6 laptop:gap-6'
        )}
      >
        <div className="w-70px h-78px laptop:w-36 laptop:h-40">
          <PdImage src={img} enableMask={false} object="contain" width={'100%'} height={'100%'} />
        </div>
        <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
          <div className="flex flex-col justify-start items-start gap-2">
            <div className={clsx('justify-start text-black/90 font-semibold text-sm', 'laptop:text-base')}>{title}</div>
            <div className="justify-start text-black/60 text-sm laptop:text-base font-normal">{desc}</div>
          </div>
          <div
            className="inline-flex justify-start items-center gap-0.5 cursor-pointer"
            onClick={() => startDownload(jumpUrl, title)}
          >
            <div className="text-center justify-start text-blue-600 text-sm font-normal leading-snug">
              {downloadUrlTitle ?? t('Download')}
            </div>
            <Image src="/icons/icon_arrow_down.svg" alt={title} width={16} height={16} />
          </div>
        </div>
      </div>
      <FormBeforeDownload
        show={downloadMeta.show}
        downloadUrl={downloadMeta.url}
        downloadFileName={downloadMeta.filename}
        beforeClose={() => setDownloadMeta({ ...downloadMeta, show: false })}
      />
    </>
  )
}

export default DownloadCard
